<script setup lang="ts">
const bEnable = ref(false)
const sPath = ref(null)

const onClickClose = () => {
  bEnable.value = false
}

const onClickOpen = (path) => {
  bEnable.value = true
  sPath.value = path
}

defineExpose({ onClickOpen })
</script>

<template>
  <v-dialog
    v-model="bEnable"
    content-class="enlarged_dialog"
  >
    <CommonImage
      class="enlarged_img"
      v-bind:src="sPath"
      object-fit="contain"
      max-height="85vh"
    />
    <div
      class="enlarged_close"
      v-on:click="onClickClose"
    >
      <v-icon
        color="#fff"
      >
        mdi-close
      </v-icon>
    </div>
  </v-dialog>
</template>

<style lang="scss" scoped>
  :deep(.enlarged_dialog) {
    position: relative;
    width: auto !important;
    height: auto;
    max-height: auto;
    padding: 15px;
    overflow: visible;
    border-radius: 0 !important;
    background-color: #fff;
  }

  :deep(.enlarged_img) {
    width: auto;
    height: auto;
    max-height: 85vh;
  }

  :deep(.enlarged_close) {
    display: flex;
    position: absolute;
    top: -15px;
    right: -15px;
    align-items: center;
    justify-content: center;
    width: 46px;
    height: 46px;
    background-color: var(--color_primary_link);
    box-shadow: 0 3px 6px rgb(0, 0, 0, 0.33);
    font-size: 30px;
    cursor: pointer;
  }
</style>
